"use client";
"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFocusControls = void 0;
const react_1 = __importDefault(require("react"));
/**
 * A react hook that provides functionality to control the styles provided
 * for the outline of a focused element.
 * @param onBlur the callback function fired when a user moves off of an element (optional)
 */
const useFocusControls = (onBlur) => {
    const [isOutlineVisible, setIsOutlineVisible] = react_1.default.useState(false);
    const ignoreFocusRef = react_1.default.useRef(false);
    const preventOutlineOnClick = react_1.default.useCallback(() => {
        ignoreFocusRef.current = true;
    }, []);
    const handleFocus = react_1.default.useCallback(() => {
        if (!ignoreFocusRef.current) {
            setIsOutlineVisible(true);
        }
        ignoreFocusRef.current = false;
    }, []);
    const handleBlur = react_1.default.useCallback((event) => {
        setIsOutlineVisible(false);
        if (onBlur) {
            onBlur(event);
        }
    }, [onBlur]);
    return [
        isOutlineVisible,
        preventOutlineOnClick,
        handleFocus,
        handleBlur
    ];
};
exports.useFocusControls = useFocusControls;
//# sourceMappingURL=useFocusControls.js.map